/* eslint-disable @typescript-eslint/no-explicit-any */
export const gaEvent = (...args: any[]) => window.gaEvent?.(...args)

// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
export const ga = ((...args: any[]) => (window.ga as any)?.(...args)) as typeof window.ga
